/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components";

import "./layout.css"
import BackgroundImage from "gatsby-background-image";

const BackgroundSection = (props) => {
  const data = useStaticQuery(graphql`
  {
    file(relativePath: {eq: "lhl_01_redigert.jpg"}) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`)
  

  return (
    <BackgroundImage
    Tag="section"
    style={{ backgroundPosition: "center"}}
    className={props.className}
    fluid={data.file.childImageSharp.fluid}
    fadeIn="critical"
    backgroundColor={`#fff`}
    >
    {props.children}
    </BackgroundImage>
  )
}


const StyledBackgroundSection  = styled(BackgroundSection)`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
  height: 100vh;
  display: flex;
  justify-content: center;
  z-index: 999;
  background-color: #fff;

/* add white background-color */
  &::before,
  &::after {
    opacity: 0.2 !important;
    transition: opacity 2s !important;
  }

  &::after {
    background-position: center !important;
  }

`

export default StyledBackgroundSection 
